export const routeSplitPrefix = '___'

export const locales = [
  { code: 'ko', language: 'ko-KR', name: 'korean', default: true },
  { code: 'en', language: 'en-US', name: 'english', default: false },
  { code: 'th', language: 'th_TH', name: 'thai', default: false },
  // { code: 'es', iso: 'es-ES', name: 'spanish', default: false },
]
